import {
    ActionIcon,
    Box,
    Image,
    Text
} from '@mantine/core';
import React from 'react';
import { FaTrash } from 'react-icons/fa';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { getTypeText } from '../utility/util';

const BoxFilePreview = ({ url, type, size = 84, onRemove = null }) => {

    return <Box style={{ position: 'relative' }}>
        <Box
            style={{ border: '1px solid #228be6', cursor: "pointer", borderRadius: 5 }}
            onClick={async () => {
                window.open(url, "_blank")
            }}
        >
            {
                type === "image"
                    ? <Image width={size} height={size} src={url} />
                    : type === "video"
                        ? <video
                            src={`${url}#t=0.1`}
                            style={{
                                cursor: 'pointer',
                                width: size,
                                height: size,
                                display: 'flex',
                                alignItems: 'center',
                                objectFit: 'cover'
                            }}
                            preload='metadata'
                            muted
                            controls={false}
                        />
                        : <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: size, height: size }}>
                            <Text color="dark" size={size < 60 ? 9 : "xs"}>{getTypeText(type)}</Text>
                        </Box>
            }
        </Box>
        {onRemove && <ActionIcon
            onClick={onRemove}
            variant='filled'
            color="yellow"
            style={{ position: 'absolute', bottom: 5, right: 5 }}
            size="sm"
        ><FaTrash size={12} /></ActionIcon>}
    </Box>
}

export default BoxFilePreview;